import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { FileTextIcon } from 'lucide-react';
// Mock data - in real app would fetch based on id
const bandoData = {
  id: 1,
  title: 'Bando 1 - Nuove Opere',
  sector: 'Creazione e Produzione',
  status: 'Aperto',
  dateFrom: '01/03/2025',
  dateTo: '31/05/2025',
  description: `Il bando finanzia progetti di produzione artistica volti alla realizzazione e promozione di opere inedite di giovani autori, artisti, interpreti ed esecutori di età non superiore ai 35 anni residenti in Italia o residenti all'estero ma con cittadinanza italiana. La proposta progettuale potrà riguardare la produzione e la promozione di una nuova opera avente carattere inedito realizzata in uno dei seguenti settori artistici: Arti visive, performative e multimediali - Cinema - Danza - Libro e lettura - Musica - Teatro. Possono partecipare tutti i soggetti pubblici e privati comprese le persone fisiche / ditte individuali che svolgono attività nei seguenti settori artistici: Arti visive, performative e multimediali - Cinema - Danza - Libro e lettura - Musica - Teatro.`,
  criteri: [{
    criterio: 'Possesso Partiva Iva',
    descrizione: 'Certificato di attribuzione partita iva.'
  }, {
    criterio: 'Soggetto Proponente con Sede legale in Italia',
    descrizione: 'Soggetto Proponente con sede legale in Italia o residenti in Italia se persone fisiche/ditte individuali'
  }, {
    criterio: 'Artista/Collettivo Under 35 Residente in Italia o con Cittadinanza Italiana',
    descrizione: "Artisti under 35 residenti in Italia o cittadini italiani residenti all'estero (se"
  }, {
    criterio: 'Massimo Due Proposte Progettuali per Ogni Soggetto Proponente',
    descrizione: "Un soggetto proponente può presentare massimo due proposte progettuali. Tale limite si applica anche nel caso in cui un soggetto proponente risulti essere, rispetto ad un altro soggetto partecipante al Bando, in una situazione di controllo societario di cui all'articolo 2359 del Codice Civile, come più dettagliatamente specificato all'art. 2 del Bando."
  }, {
    criterio: 'Data di Costituzione',
    descrizione: "Data di costituzione anteriore di almeno 3 (tre) anni alla data di pubblicazione del presente Bando, ovvero il 15.09.2025, comprovata da Visura Camerale se iscritti al Registro delle Imprese, oppure dall'Atto costitutivo dell'organizzazione, oppure dal certificato di attribuzione della partita IVA"
  }, {
    criterio: 'Contributo Massimo Assegnabile per Singolo Progetto',
    descrizione: 'Massimo € 40.000,00 per i settori: Arti visive, performative e multimediali, Cinema, Danza, Musica e Teatro. Per il settore Libro e lettura, ai progetti che prevedono la realizzazione di una sola nuova opera potrà essere assegnato un contributo massimo pari a € 20.000,00; ai progetti che prevedono la realizzazione di due nuove opere potrà essere assegnato un contributo massimo pari a € 40.000,00.'
  }, {
    criterio: 'Nuova opera avente carattere inedito',
    descrizione: "Il progetto deve riferirsi alla creazione di una nuova opera avente carattere inedito ovvero la cui pubblicazione o diffusione al pubblico dovrà avvenire, pena l'esclusione, non prima del 02.03.2026, termine ultimo previsto per la pubblicazione delle graduatorie dei soggetti vincitori del presente Bando, ed entro il termine stabilito per la conclusione dei progetti, ovvero entro e non oltre il 28.02.2027"
  }, {
    criterio: 'Contributi da parte del Ministero della Cultura (MiC)',
    descrizione: 'Non possono essere finanziati i progetti che siano già beneficiari, a qualunque titolo, di contributi da parte del Ministero della Cultura.'
  }, {
    criterio: 'Comprovata esperienza nel settore di riferimento',
    descrizione: "che svolgono attività professionale di produzione e/o edizione e/o distribuzione artistica comprovata dalla documentazione indicata all'art. 3 del bando per il settore artistico di riferimento della candidatura."
  }],
  documenti: [{
    nome: 'Certificato di attribuzione della partita IVA',
    formato: 'PDF'
  }, {
    nome: "Visura camerale in corso di validità per i soggetti iscritti al Registro delle Imprese oppure Atto costitutivo e Statuto dell'organizzazione. Solo per le persone fisiche/ditte individuali, in assenza di Visura camerale oppure Atto costitutivo e Statuto, è obbligatorio inviare documentazione attestante la titolarità della produzione da parte della persona fisica/ditta individuale proponente di ciascuna delle n. 5 produzioni afferenti al settore di riferimento della candidatura, realizzate nel periodo compreso tra il 01.09.2020 e il 1.09.2025 secondo le tipologie indicate all'art. 3 e all'art. 7 del Bando PDF",
    formato: 'PDF'
  }, {
    nome: "Copia del documento d'identità in corso di validità del rappresentante legale del soggetto proponente o della persona fisica/ditta individuale proponente",
    formato: 'PDF'
  }, {
    nome: "Copia del contratto o lettera di impegno precontrattuale sottoscritto tra il soggetto proponente e l'artista/il collettivo proposto, nel quale, a discrezione del soggetto proponente, potranno essere oscurate eventuali informazioni non rilevanti ai fini della dimostrazione dell'impegno contrattuale tra le parti per la realizzazione del progetto",
    formato: 'PDF'
  }, {
    nome: "Materiali (progetti, immagini, video, file audio, altro, a seconda della tipologia di opera) rappresentativi della nuova opera che si intende realizzare. Non è ammessa la trasmissione di documentazione tramite link. Qualora tale documentazione dovesse superare il limite massimo di 2Gb previsto per gli allegati, si consente l'invio di parti o frammenti, purché autonomamente rilevanti ai fini della valutazione",
    formato: 'PDF/JPG/PNG/MP3/MP4'
  }, {
    nome: "Autocertificazione attestante la regolarità dei pagamenti dovuti a SIAE in termini di diritto d'autore, utilizzando la specifica modulistica predisposta da SIAE e allegata al Bando, coerentemente con quanto previsto agli art. 17 e 18 del presente Bando",
    formato: 'PDF'
  }]
};
type TabId = 'descrizione' | 'criteri' | 'documentazione';
const tabs: {
  id: TabId;
  label: string;
}[] = [{
  id: 'descrizione',
  label: 'Descrizione'
}, {
  id: 'criteri',
  label: 'Criteri'
}, {
  id: 'documentazione',
  label: 'Documentazione'
}];
export function BandoDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const [activeTab, setActiveTab] = useState<TabId>('descrizione');
  return <div className="space-y-6" data-id="element-537">
      {/* Main Card */}
      <div className="bg-white" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4'
    }} data-id="element-538">
        {/* Header Section */}
        <div className="p-8" data-id="element-539">
          <div className="flex justify-between items-start mb-2" data-id="element-540">
            <h1 style={{
            fontSize: '28px',
            fontWeight: 400,
            color: '#293B54',
            fontFamily: 'Roboto, sans-serif',
            margin: 0
          }} data-id="element-541">
              Dettagli Bando
            </h1>
            <Button variant="primary" style={{
            backgroundColor: '#293B54',
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '14px',
            letterSpacing: '0.5px',
            borderRadius: '9999px'
          }} data-id="element-542">
              VEDI CANDIDATURE
            </Button>
          </div>
          <p style={{
          fontSize: '16px',
          color: '#80858E',
          fontFamily: 'Roboto, sans-serif',
          margin: 0
        }} data-id="element-543">
            {bandoData.title}
          </p>
        </div>

        {/* Tabs */}
        <div className="px-8" style={{
        borderBottom: '1px solid #E4E4E4'
      }} data-id="element-544">
          <div className="flex gap-6" data-id="element-545">
            {tabs.map(tab => <button key={tab.id} type="button" onClick={() => setActiveTab(tab.id)} className="relative pb-3 transition-colors" style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '14px',
            fontWeight: activeTab === tab.id ? 500 : 400,
            color: activeTab === tab.id ? '#2A3A54' : 'rgba(71, 80, 95, 0.7)',
            background: 'none',
            border: 'none',
            cursor: 'pointer'
          }} data-id="element-546">
                {tab.label}
                {activeTab === tab.id && <span className="absolute bottom-0 left-0 right-0" style={{
              height: '2px',
              backgroundColor: '#2A97DF'
            }} data-id="element-547" />}
              </button>)}
          </div>
        </div>

        {/* Tab Content */}
        <div className="p-8 pt-6" data-id="element-548">
          {activeTab === 'descrizione' && <div style={{
          fontFamily: 'Roboto, sans-serif',
          fontSize: '14px',
          lineHeight: 1.7,
          color: '#444444'
        }} data-id="element-549">
              {bandoData.description}
            </div>}

          {activeTab === 'criteri' && <div data-id="element-550">
              {/* Warning Banner */}
              <div className="mb-6 p-4" style={{
            backgroundColor: '#FFF8E1',
            border: '1px solid #FFE082',
            borderRadius: '4px'
          }} data-id="element-551">
                <p style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              color: '#E65100',
              margin: 0
            }} data-id="element-552">
                  Questi criteri sono puramente indicativi. Consultare il bando
                  per visualizzare l'elenco esaustivo.
                </p>
              </div>

              {/* Criteria Table */}
              <table className="w-full" style={{
            borderCollapse: 'collapse'
          }} data-id="element-553">
                <thead data-id="element-554">
                  <tr data-id="element-555">
                    <th className="text-left pb-4" style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: '#293B54',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  width: '30%'
                }} data-id="element-556">
                      CRITERIO
                    </th>
                    <th className="text-left pb-4" style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: '#293B54',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }} data-id="element-557">
                      DESCRIZIONE
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-558">
                  {bandoData.criteri.map((criterio, index) => <tr key={index} style={{
                borderTop: '1px solid #E4E4E4'
              }} data-id="element-559">
                      <td className="py-4 pr-6 align-top" style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  color: '#2A97DF'
                }} data-id="element-560">
                        {criterio.criterio}
                      </td>
                      <td className="py-4 align-top" style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  color: '#444444',
                  lineHeight: 1.6
                }} data-id="element-561">
                        {criterio.descrizione}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}

          {activeTab === 'documentazione' && <div data-id="element-562">
              {/* Documents Table */}
              <table className="w-full" style={{
            borderCollapse: 'collapse'
          }} data-id="element-563">
                <thead data-id="element-564">
                  <tr data-id="element-565">
                    <th className="text-left pb-4" style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: '#293B54',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }} data-id="element-566">
                      DOCUMENTI RICHIESTI
                    </th>
                    <th className="text-left pb-4" style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: '#293B54',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  width: '150px'
                }} data-id="element-567">
                      FORMATO
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-568">
                  {bandoData.documenti.map((doc, index) => <tr key={index} style={{
                borderTop: '1px solid #E4E4E4'
              }} data-id="element-569">
                      <td className="py-4 pr-6 align-top" style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  color: '#444444',
                  lineHeight: 1.6
                }} data-id="element-570">
                        {doc.nome}
                      </td>
                      <td className="py-4 align-top" style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  color: '#80858E'
                }} data-id="element-571">
                        {doc.formato}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}
        </div>
      </div>
    </div>;
}